import Vue from 'vue'
import VueRouter from 'vue-router'
import allRoutes from './routes'

import store  from '@/store'

Vue.use(VueRouter)

const routes = allRoutes

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})


router.beforeEach((to, from, next) => {
    const requiresAuth = to.matched.some(record => record.meta.requiresAuth); // Verifica si la ruta requiere autenticación
    const isLogged = store.state["auth"].isLogged; // Verifica si el usuario está logueado
    const user = store.state["auth"].user; // Obtén el objeto del usuario

    // Verificamos si el usuario está logueado y si tiene un objeto user (no es null)
    if (!requiresAuth && isLogged) {
        // Si no se requiere autenticación y el usuario está logueado
        if (user && user.isAdmin === 1) {
        next('/admin-dashboard'); // Redirige al admin-dashboard si el usuario es admin
        } else {
        next('/inicio'); // Redirige a inicio si el usuario no es admin
        }
    } else if (requiresAuth && !isLogged) {
        // Si la ruta requiere autenticación y el usuario no está logueado, redirige a la página de login
        next('/');
    } else {
        next(); // Permite el acceso si todo está bien
    }
});

export default router
